import { SET_INPUT } from '../actions';

const INITIAL_STATE = {
  input: ''
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_INPUT:
      return {...state, input: action.payload};
    default:
      return state;
  }
}